export default __webpack_public_path__ + "static/media/relax_on_the_beach.0e90013d.png";